import {Injectable} from '@angular/core';

declare var document: any;
declare global {
    interface Window {
        google: any;
    }
}

@Injectable({
    providedIn: 'root'
})
export class GStaticChartService {

    constructor() {
    }


    public load() {
        return new Promise((resolve) => {
            const dynamicScriptUrl = 'https://www.gstatic.com/charts/loader.js';

            const node = document.createElement('script');
            node.src = dynamicScriptUrl;
            node.type = 'text/javascript';
            node.async = false;
            node.charset = 'utf-8';
            node.onload = () => {
                resolve(window.google);
            };
            document.getElementsByTagName('head')[0].appendChild(node);
        });
    }
}
